export default __webpack_public_path__ + "static/media/Conference_Announcement.38ae0849.pdf";